export default "__VITE_ASSET__VkPBUsfL__"